module.exports = __webpack_public_path__ + "static/media/tow-truck-2901948_640_color.df98cfb9.png";